'use client'

import {useContext} from 'react'

import {Context} from '../../../Header/Context'
import {useIsOnMobile} from '../../../hooks/useIsOnMobile'
import {useModalsContext} from '../../../hooks/useModalContext'
import type {TLink} from './Link'

type GoalLinkProp = Omit<TLink, 'href'> & {href: string}

export function GoalLink({onClick: onClickExternal, goal, ...linkProps}: GoalLinkProp) {
  const {href} = linkProps
  const {dispatch} = useModalsContext()
  const {reachGoal} = useContext(Context)
  const isOnMobile = useIsOnMobile()
  const isModal = href?.toString().includes('$modal:')
  const hrefSegments = isModal ? href.toString().split(':') : []

  return (
    <a
      onClick={e => {
        if (isModal && (isOnMobile || hrefSegments.length !== 3)) {
          e.preventDefault()
          dispatch({type: 'setOpen', payload: hrefSegments[1]})
        }

        goal && reachGoal?.(goal)
        onClickExternal?.(e)
      }}
      {...linkProps}
      href={isModal && hrefSegments.length === 3 && !isOnMobile ? hrefSegments[2] : href}
    />
  )
}
